import request from '@/utils/request'
import mqtt from '@/utils/mqtt'

//投标报价
export const saveOfferAgain = (data) => {
   return request.post('/api/bid/offer/again', data)
}

//获取报价配置
export const getOfferConfigList = (sectionCode) => {
   return request.get('/api/bid/offer/config/list?sectionCode='+sectionCode)
}
//获取报价列表
export const getOfferConfig = (data) => {
   return request.post('/api/bid/offer/config', data)
}
//评标 - 获取报价列表
export const getOfferListForEvaluation = (sectionCode) => {
   return request.get('/api/bid/offer/list?sectionCode='+sectionCode)
}

// 客观打分topic监听
export const subscribeExpertScore = (sectionCode) => {
   return request.get('/api/mqtt/expert/score?sectionCode='+sectionCode)
}

